import React, { useState, useContext } from "react";
import styles from "./Header.module.scss";
import imagePaths from "../../constants/imagePaths";
import { StoreContext } from "../../components/ContextStore/StoreContextProvider";
import { useEffect } from "react";
import { getCookie, deleteCookie, setCookie } from "../../utils/utils";
import { useHistory } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import Dropdown from "react-dropdown";
import "./dropDown.scss";
import { doSSOLogout } from "../../firebase/ssoAuthenticate";
import GaEventHelper from '../../helper/ga-event-helper';
import { GA_EVENTS } from '../../common/gaEventConstants';
import { logoutService } from "../../services/SessionService";
import CountryDropdown from "../common/CountryDropdown/CountryDropdown";
import HeaderTimeDetails from "./HeaderTimeDetails/HeaderTimeDetails";
import { DropdownContext } from "./HeaderTimeDetails/DropdownContext";
import { ROLES } from "../../constants/roles";
import { ROLESID } from "../../constants/rolesID";
import { ROLESBD } from "../../constants/rolesBD";
import { isMobile } from "react-device-detect";
import { isShadowUser as checkShadowUser } from "../../helper/effectiveEmailHelper";

const TABS = [
  { key: "team", label: "Team View" },
  { key: "distributor", label: "Distributor" },
  { key: "disciplinary", label: "Disciplinary KPIs" },
];

const TAB_GA_INDEX = { team: 0, distributor: 1, disciplinary: 2 };


const Header = ({ ucube }) => {
  const { header: headerImages, common, landingHeader } = imagePaths;
  const history = useHistory();
  const selectedApp = localStorage.getItem("selectedApp");
  console.log("selectedApp", selectedApp);
  const [menu, setMenu] = useState(false);
  const {
    userDetails,
    updateSelectedBsa,
    selectedBsa,
    updateCountryCode,
    selectedCountryCode,
  } = useContext(StoreContext);
  const { selectedValue, setSelectedValue, selectedView, activeTab, setActiveTab } = useContext(DropdownContext);

  const isShadowUser = checkShadowUser(userDetails);

  const isTeamLead = !!(
    userDetails?.role === ROLES.TEAM_LEAD ||
    userDetails?.role === ROLESID.TEAM_LEAD ||
    userDetails?.role === ROLESBD.TEAM_LEAD
  );

  const currentPath = history?.location?.pathname;
  const showTabs = !!(
    (selectedView && currentPath === "/homepage") ||
    currentPath === "/teamlevels" ||
    currentPath === "/distributorteamlevels" ||
    currentPath === "/disciplinaryteamlevels"
  );
  const dropdownValue = localStorage.getItem("selectedDropdownLabel");
  const isLocateView = currentPath === "/locate";
  const headerTitle = isLocateView ? "Ucube Locate" : "Sales Hierarchy Performance Hub";
  const showHeaderTimeDetails = showTabs || currentPath === "/locate";

  const onTabChange = (tabKey) => {
    if (isTeamLead && tabKey === "distributor") return;

    // If on team details page (/teamlevels), navigate back to homepage with selected tab
    if (currentPath === "/teamlevels") {
      const navigationState = {};
      if (tabKey === "distributor") {
        navigationState.isDistributor = true;
      } else if (tabKey === "disciplinary") {
        navigationState.isDisciplinary = true;
      } else {
        navigationState.isTeam = true;
      }
      history.push("/homepage", navigationState);
    } else {
      setActiveTab(tabKey);
      // Clear history state to prevent stale navigation flags from interfering with tab rendering
      history.replace(history.location.pathname, {});
    }

    GaEventHelper.gaCommonEvent({
      userDetails: userDetails,
      screen_name: history?.location?.pathname?.replace('/', ''),
      event: GA_EVENTS.select_ucube_tabs[TAB_GA_INDEX[tabKey]],
      selected_period: dropdownValue,
    });
  };

  const [currentbsa, setCurrentbsa] = useState({});
  const handleMenu = () => {
    setMenu(!menu);
  };
  const handleBsaChange = (data) => {
    setCurrentbsa(data.label);
    updateSelectedBsa(data.label);
  };

  useEffect(() => {
    setCurrentbsa(userDetails && userDetails.bsa);
    updateCountryCode(localStorage.getItem("countryCode"));
    setCookie("countryCode", localStorage.getItem("countryCode"));  
  }, [selectedBsa, updateCountryCode, userDetails]);

  useEffect(() => {
    if (
      history &&
      history.location &&
      history.location.pathname === "/operationalreportslandingpage"
    ) {
      localStorage.setItem("selectedApp", "operational");
    } else if (
      history &&
      history.location &&
      history.location.pathname === "/homepage"
    ) {
      localStorage.setItem("selectedApp", "ucube");
    } else if (
      history &&
      history.location &&
      history.location.pathname === "/useraccess"
    ) {
      localStorage.setItem("selectedApp", "useraccess");
    }
  }, [history]);
  console.log(userDetails);
  console.log(currentbsa);

  const onUcubeClick = () => {
    localStorage.setItem("selectedApp", "ucube");
    const location = {
      pathname: "/homepage",
    };
    history.replace(location);
    history.push({ state: { ucube: true } });
  };
  const onBackButtonClick = (clickedOn) => {
    GaEventHelper.gaCommonEvent({
      userDetails: userDetails,
      screen_name: history?.location?.pathname?.replace('/', ''),
      event: clickedOn === "homeIcon" ? GA_EVENTS.select_home_icon : GA_EVENTS.go_back_navigation,
    });
    const location = {
      pathname: "/landingscreen",
    };
    history.replace(location);
  };
  const onUsermanagementClick = () => {
    localStorage.setItem("selectedApp", "useraccess");
    const location = {
      pathname: "/useraccess",
    };
    setMenu(false);
    history.replace(location);
  };

  const onOperationalDashboardsClick = () => {
    //localStorage.setItem("selectedApp","operational");
    const location = {
      pathname: "/landingscreen",
    };
    history.replace(location);
    history.push({ state: { ucube: false } });
  };

  const logoutHandler = async () => {
    GaEventHelper.gaCommonEvent({userDetails: userDetails, screen_name:history?.location?.pathname?.replace('/',''),event: GA_EVENTS.logout })
    logoutService(selectedCountryCode);
    if (getCookie("isSSOLogin") || getCookie("isMFALogin")) {
      await doSSOLogout();
      getCookie("idToken") && deleteCookie("idToken");
      getCookie("refreshToken") && deleteCookie("refreshToken");
      getCookie("isSSOLogin") && deleteCookie("isSSOLogin");
      getCookie("isMFALogin") && deleteCookie("isMFALogin");
      getCookie("countryCode") && deleteCookie("countryCode")
      localStorage.removeItem("countryCode");
      localStorage.removeItem("isIndonesia");
      localStorage.removeItem("isIndonesiaIc");
      localStorage.removeItem("isVietnam");
      localStorage.removeItem("isPhilipines");
      localStorage.removeItem("isThailand");
      localStorage.removeItem("isPakistan");
      localStorage.removeItem("isCambodia");
      localStorage.removeItem("isLaos");
      localStorage.removeItem("isMalaysia");
      localStorage.removeItem("adminAccess");
      localStorage.removeItem("selectedDropdownLabel");
      localStorage.removeItem("email");
      localStorage.removeItem("isSSOLogin");
      localStorage.removeItem("loginType");
      localStorage.removeItem("UUID");
      localStorage.removeItem("localId");
      history.push("/login");
    }
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.headertop}>
            <div className={styles.dttReports} onClick={() => onBackButtonClick("homeIcon")}>
            
              <img src={common.logos.ucubeAiFrame} alt="" className={styles.ucubeAiFrame} />
          </div>
          <div className={menu ? styles.menuSide : styles.navlinks}>
            {userDetails &&
              userDetails.accessToUcube === "YES" &&
              userDetails.role !== null && (
                <div onClick={onUcubeClick}>
                  <img src={headerImages.ucubeGraphBlue} className={styles.menuIcons} alt="" />{" "}
                  <p
                    className={selectedApp === "ucube" ? styles.underLine : ""}
                  >
                    {" "}
                    UCube
                  </p>
                </div>
              )}
            {userDetails &&
              userDetails.accessToOperationalDashboards === "YES" && (
                <div onClick={onOperationalDashboardsClick}>
                  <img src={headerImages.opDashboardBlue} className={styles.menuIcons} alt="" />
                  <p
                    className={
                      selectedApp === "operational" ? styles.underLine : ""
                    }
                  >
                    {" "}
                    Reports & Analytics Home
                  </p>
                </div>
              )}
            {userDetails && userDetails.userType === "admin" && (
              <div onClick={onUsermanagementClick}>
                <img src={headerImages.userManageBlue} className={styles.menuIcons} alt="" />
                <p
                  className={
                    selectedApp === "useraccess" ? styles.underLine : ""
                  }
                >
                  {" "}
                  User management
                </p>
              </div>
            )}
            <span onClick={logoutHandler}>
              <img src={headerImages.logout} className={styles.logout} alt="" />
              <img src={headerImages.logoutBlue} className={styles.logout_blue} alt="" />
              <p>Logout</p>
            </span>
          </div>
          <div className={styles.country_popup}>
            <CountryDropdown containerClassName={styles.countryName} />
            <div className={styles.profileIcon} onClick={()=> {
                GaEventHelper.gaProfileEvent({userDetails: userDetails, screen_name:history?.location?.pathname?.replace('/',''),event: GA_EVENTS.Profile_view,selectedBsa:selectedBsa?selectedBsa:userDetails.bsa[0]})
              }}>
              <img
                src={common.icons.profileIcon}
                alt="Profileicon"
                data-tooltip-id="profilePopup"
              />
            </div>
            <Tooltip
              className={styles.popupModal}
              id="profilePopup"
              place="bottom"
              openOnClick="true"
              offset="8"
              noArrow
              clickable
            >
              <div className={styles.popup}>
                <div className={styles.popupDetails}>
                  <img
                    className={styles.popupProfileIcon}
                    src={landingHeader.user}
                    alt="Profile"
                  />
                  <div className={styles.profileText}>
                    <h4>{userDetails.name}</h4>
                    <p>{userDetails.email}</p>
                  </div>
                </div>
                <div className={styles.userDetailsPopup}>
                  <span className={`${styles.popup_role} ${styles.popup_role_stack}`}>
                    <p className={styles.popup_role_label}>Role</p>
                    <p>
                      {isShadowUser
                        ? `Shadow User (${String(userDetails.role ?? "").toUpperCase()})`
                        : userDetails.role}
                    </p>
                  </span>
                  {isShadowUser && (
                    <span className={`${styles.popup_role} ${styles.popup_role_stack}`}>
                      <p className={styles.popup_role_label}>Parent Email ID</p>
                      <p>{userDetails.parentEmail}</p>
                    </span>
                  )}
                  <span className={`${styles.popup_role} ${styles.popup_role_bsa}`}>
                    <p className={styles.popup_role_label}>Business Scope Assignment</p>
                    {/* {
                    Object.keys(userDetails).length > 0 &&
                    <select
                      className={styles.popupDetails_bsaDropdown}
                      value={selectedBsa}
                      onChange={handleBsaChange}
                      data-testid="select"
                    >
                      {userDetails && userDetails.bsa && userDetails.bsa.map((data) => (
                        <option data-testid="select-option" value={data}>{data}</option>
                      ))}
                    </select>
                  } */}
                    {userDetails && userDetails.bsa && (
                      <div className="popupDropDown-container">
                        <Dropdown
                          options={userDetails.bsa}
                          onChange={handleBsaChange}
                          value={
                            selectedBsa ? selectedBsa : userDetails.bsa[0]
                          }
                        />
                        {/* <img src={dropdownBlue} alt="dropdown"/> */}
                      </div>
                    )}
                  </span>
                </div>
                <div onClick={logoutHandler} className={styles.popupLogout}>
                  <img
                    src={landingHeader.logout}
                    alt="Logout"
                  />
                  <p>Logout</p>
                </div>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
      {isMobile && (
        <div className={styles.headerbottomMobile}>
          <div className={styles.flexibleRow}>
            <img
              src={menu ? landingHeader.closeIcon : landingHeader.hamMenu}
              alt="menu"
              onClick={handleMenu}
            />
            {!menu && (
              <img
                src={common.logos.ucubeAiFrame}
                alt="UCube.Ai"
                className={styles.mobileCenterLogo}
                onClick={() => onBackButtonClick("homeIcon")}
              />
            )}
            <CountryDropdown isMobileView />
          </div>
        </div>
      )}
      {!isMobile && (
        <div className={menu ? styles.menuOpenView : styles.mobileViewAdjust}>
        <div className={`${menu ? styles.noneHeader : styles.header1} ${isLocateView ? styles.header1Locate : ""}`}>
          <h2 className={styles.ucubeFieldForceLogo}>{headerTitle}</h2>
        {showTabs && (
            <div className={styles.tabBarTabs}>
              {TABS.map((tab) => (
                <div
                  key={tab.key}
                  className={`${styles.tabItem} ${activeTab === tab.key ? styles.tabItemActive : ""}`}
                  onClick={() => onTabChange(tab.key)}
                >
                  <p>{tab.label}</p>
                </div>
              ))}
            </div>
          )}
          {showHeaderTimeDetails && (
            <div className={`${styles.header1Right} ${isLocateView ? styles.header1RightLocate : ""}`}>
              <HeaderTimeDetails selectedValue={selectedValue} setSelectedValue={setSelectedValue} isLocateView={isLocateView} />
            </div>
          )}
        </div>
        <div className={menu ? styles.headerSidebar : styles.headerbottom}>
          <div className={styles.hamMenu} onClick={handleMenu}>
            <img src={menu ? headerImages.crossMenu : headerImages.hamMenu} alt="menu" />
          </div>
          <div>
            <div className={styles.details}>
              <p className={styles.detailsRole}>
                Role <b>{userDetails.role}</b>
              </p>
              <p className={`${styles.assignment} bsaDropDownMobile`}>
                <span>Business Scope Assignment</span>
                 {
            Object.keys(userDetails).length>0 &&
              <select
              className={styles.bsaDropdown}
              value={selectedBsa}
              onChange={handleBsaChange}
              data-testid="select"
              >
              {userDetails && userDetails.bsa && userDetails.bsa.map((data)=>(
                <option data-testid="select-option" value={data}>{data}</option>
                ))}
            </select>
              } 
                {userDetails && userDetails.bsa && (
                  <Dropdown
                    options={userDetails.bsa}
                    onChange={handleBsaChange}
                    value={selectedBsa ? selectedBsa : userDetails.bsa[0]}
                    arrowClosed={<span className="arrow-closed" />}
                    arrowOpen={<span className="arrow-open" />}
                  />
                )}
              </p>
            </div>
          </div>
        </div>
      </div> 
      )}
      
    </>
  );
};

export default Header;
